//全局变量
const state = {
        //本地token持久化，用于子系统跳转登陆使用
        token_local: '',
		}
    //改变变量只能通过方法执行改变
const mutations = {
    //同步方法
    SET_TOKEN_LOCAL: (state, token) => {
        state.token_local = token
    },
}
const actions = {
    // 异步执行调用方法,commit代表同步的方法提交,dispatch代表异步的方法提交
    // resolve返回的值,这个值就是方法运行结束后,所返回的值,可以是对象,也可以是变量
    // 异步方法需要按顺序执行时,或者需要当方法运行结束后需要干什么的时候,用到promise,方法后then调用后续函数
    set_token_local({
        commit,
        state
    }, token) {
        return new Promise(resolve => {
            commit('SET_TOKEN_LOCAL', token)
            resolve(state.token_local)
        })
    },
}
export default {
    namespaced: true,
    state,
    mutations,
    actions
}


// WEBPACK FOOTER //
// ./src/store/modules/Token.js